
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/member-get-member",
      function () {
        return require("private-next-pages/member-get-member.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/member-get-member"])
      });
    }
  